import { z } from 'zod';
import { cardStateOrderedSchema } from '../CardState.ts';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
const mechanicProgressCardsPlayerStateSchema = z.object({
    progressCards: cardStateOrderedSchema.readonly()
}).strict();
const mechanicProgressCardsPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicProgressCardsPlayerStateSchema);
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
const mechanicProgressCardsPlayersSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicProgressCardsPlayerStateSchema);
export const mechanicProgressCardsStateSchema = z.object({
    bankProgressCards: cardStateOrderedSchema.readonly(),
    players: mechanicProgressCardsPlayersSchema
}).strict();
export function validateMechanicProgressCardsState(data) {
    return validateState(mechanicProgressCardsStateSchema, data);
}
const mechanicProgressCardsPlayersPartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicProgressCardsPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
const mechanicProgressCardsStatePartialShapeSchema = z.object({
    bankProgressCards: cardStateOrderedSchema,
    players: mechanicProgressCardsPlayersPartialSchema
}).strict();
export const mechanicProgressCardsStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicProgressCardsStatePartialShapeSchema);
